import { SaleOrderDepartureSerialNumber } from './sale-order-departure-serial-number';

export class SaleOrderDeparture {
  constructor(
    public hash?: string,
    public departureDate?: number,
    public authorizingPersonHash?: string,
    public authorizingPersonName?: string,
    public requestMadeByHash?: string,
    public requestMadeByName?: string,
    public saleOrderDepartureReasonHash?: string,
    public saleOrderDepartureReasonName?: string,
    public observations?: string,
    public saleOrderDepartureSerialNumbers?: SaleOrderDepartureSerialNumber[],
    public duration?: number,
    public durationDate?: number
  ) { }

  clone() {
    return new SaleOrderDeparture(
      this.hash,
      this.departureDate,
      this.authorizingPersonHash,
      this.authorizingPersonName,
      this.requestMadeByHash,
      this.requestMadeByName,
      this.saleOrderDepartureReasonHash,
      this.saleOrderDepartureReasonName,
      this.observations,
      this.saleOrderDepartureSerialNumbers,
      this.duration,
      this.durationDate
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-departure.ts